module.exports = __webpack_public_path__ + "static/media/rec.4e98763c.mp4";